<script lang="ts" setup>

  import type { BreadcrumbItem } from './Breadcrumb.type'
  import BngBreadcrumbItem from './BreadcrumbItem.vue'

  type Props = {
    items: BreadcrumbItem[]
  }
  const props = defineProps<Props>()
</script>
<template>
  <div class="c-breadcrumb">
    <BngBreadcrumbItem
      v-for="(item, k) in props.items"
      :key="k"
      :item-key="k"
      :label="item.label"
      :link="item.link ?? ''"
    />
  </div>
</template>
<style  scoped>

.c-breadcrumb {
  display: flex;
  flex-direction: row;
}
</style>
